import { OnInit, Component } from '@angular/core';

@Component({
    selector: 'app-detalle-alerta',
    templateUrl: './detalle-alerta.component.html',
  })

  export class DetalleAlertaComponent implements OnInit {
      ngOnInit() {
          
      }
  }